// extracted by mini-css-extract-plugin
module.exports = {"checkbox-switch":"Checkbox_checkbox-switch__PAKqU","checkbox-slider":"Checkbox_checkbox-slider__xnD4O","round":"Checkbox_round__zd5I9","checkbox":"Checkbox_checkbox__9AKZ1"};